import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Grid } from '@mui/material';

import styles from './styles.module.scss';
import {displayErrorMessage} from "../../../../utils/displayErrorMessage";

const AskSpecialistWidget = ({ style = {} }) => {

  return (
    <Box className={styles.widgetPaper} sx={style}>
      <Grid container direction="column" justifyContent="space-between" alignContent="center" alignItems="center" className={styles.widgetContent}>
        <Box className={styles.text}>I am here to answer your queries & help you find the best loan!</Box>
        <Button color="primary" variant="contained" onClick={() => displayErrorMessage(null, 'Not implemented yet')} fullWidth data-testid="button-ask-specialist-widget">
          ASK YOUR SPECIALIST
        </Button>
      </Grid>
    </Box>
  )
};

AskSpecialistWidget.propTypes = {
  style: PropTypes.object
};

export default AskSpecialistWidget;